module.exports = __webpack_public_path__ + "img/Coaxer.14a7e002.jpg";